import { type PropsWithChildren, type ReactNode, useMemo, useState } from 'react';

import type { PremiseStatusV2 } from '@dte/otw-azure-functions/src/common/interfaces/api/PremiseStatusV2';

import { AuthenticatedJsonContent } from '../../../content/jsonGet/AuthenticatedJsonContent';
import { usePremiseId } from '../usePremiseId';
import { getPremiseStatusURL } from './getPremiseStatusURL';
import styles from './PremiseSectionHeader.module.scss';

export interface PremiseSectionHeaderProps extends PropsWithChildren {}

export function PremiseSectionHeader(props: PremiseSectionHeaderProps): ReactNode {
	const premiseId = usePremiseId();
	const url = getPremiseStatusURL(premiseId);
	const [status, setStatus] = useState<PremiseStatusV2>();

	const classes = useMemo(() => {
		const classNames = [styles['header']];

		// Something recent or open
		if (status?.startDate) {
			// See if it was an outage
			if (status?.outage) {
				classNames.push(styles['outage']);
			} else {
				classNames.push(styles['nonOutage']);
			}

			// See if it's still open
			if (!status?.closeDate) {
				classNames.push(styles['open']);
			}
		}

		return classNames;
	}, [status]);

	return (
		<>
			<h2 className={classes.join(' ')}>{props.children}</h2>
			<AuthenticatedJsonContent url={url} setData={setStatus} />
		</>
	);
}
